import { useEffect, useState } from "react";
import { Card, CardBody } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import EnterpriseService from "../../common/services/enterprise-service";
import ServerStatusBadge from './ServerStatusBadge';

const CompanyServers = ({ container, company_id }) => {

    const [servers, setServers] = useState([]);
    const es = new EnterpriseService();
    const [serversStatus, setServersStatus] = useState({});

    useEffect(() => {
        getServers();
    }, []);

    const getServers = async () => {
        const result = await es.getCompanyServers(company_id);
        setServers(result);
    };

    return (
        <>
            {servers.map(m => {
                return (
                    <div className="server-widget mt-3">
                        <div className="server-widget-icon">
                            <FontAwesomeIcon icon="server" className="mx-0"></FontAwesomeIcon>
                        </div>
                        <div className="server-widget-body">
                            <div className="server-widget-title">
                                {m.lobby_name}{" "}
                                <span className="server-widget-game">({m.game.code})</span>
                            </div>
                            <ServerStatusBadge container={container} server={m} size="sm" showPassword={true}></ServerStatusBadge>
                        </div>
                    </div>
                )
            })}
        </>
    );
};

export default CompanyServers;
